// Pantry storage shared by app and HTTP/MCP operations, without native/runtime dependencies.
import {toNumber,fromNumber,type Amount} from './quantity.ts';
import {resolveUnit,convert,type CustomUnit} from './units.ts';
import {addDays} from './dates.ts';
import type {Pantry,GroceryItem,Id,Day} from '../types';
const roundTo3=(n:number)=>toNumber(fromNumber(n));
export function storePantryItem(items:Pantry['items'],item:GroceryItem,value:number,customUnits:Record<string,CustomUnit>,today:Day):void{
  if (item.kind === 'utensil') {
    const existing = items.findIndex(p => p.kind === 'utensil' && p.refId === item.refId);
    if (existing >= 0) items[existing] = { ...items[existing], amount: items[existing].amount + value, dirty: false, estimate: 'estimated' };
    else items.push({ kind: 'utensil', refId: item.refId, amount: value, unit: null, dirty: false, estimate: 'estimated' });
    return;
  }
  const unit = resolveUnit(item.unit, customUnits);
  const expiresOn = addDays(today, 7);
  for (let i = 0; i < items.length; i++) {
    const p = items[i];
    if (p.kind !== 'ingredient' || p.refId !== item.refId) continue;
    const pUnit = resolveUnit(p.unit, customUnits);
    let converted: number | null = null;
    if (!unit && !pUnit) converted = value;
    else if (unit && pUnit) converted = JSON.stringify(p.unit) === JSON.stringify(item.unit) ? value : convert(value, unit, pUnit);
    if (converted !== null) {
    items[i] = { ...p, amount: roundTo3(p.amount + converted), expiresOn, estimate: 'estimated' };
    return;
    }
  }
  items.push({ kind: 'ingredient', refId: item.refId, amount: roundTo3(value), unit: item.unit, expiresOn, estimate: 'estimated' });
}
export function addToPantry(pantry:Pantry,items:{refId:Id;amount:Amount;unit:GroceryItem['unit']}[],customUnits:Record<string,CustomUnit>,today:Day):Pantry{
 const next=[...pantry.items];
 for(const [index,item]of items.entries())storePantryItem(next,{...item,id:`p${index}`,kind:'ingredient',checked:true},toNumber(item.amount),customUnits,today);
 return {items:next,updatedAt:Date.now()};
}
